module.exports = __webpack_public_path__ + "img/130.e025d1b5.png";